import React from 'react';
import { useSelector } from "react-redux";
import { selectOpMode } from "../../util/store/selectors";
import { durationTxt, getStartFinishByOpMode } from "../../util/varibles/global";
import { IActivityLog } from "../../util/varibles/interface";
import Icon, { ICON_NAME } from "../Icon";
import styles from './style.module.scss';

interface IProps {
    visible?: boolean
    more?: boolean
    activity_log: IActivityLog[]
}

const Duration: React.FC<IProps> = (props) => {
    const { visible = true, activity_log, more = true } = props;
    const mode = useSelector(selectOpMode);
    if (!visible) return null;
    const { start, finish } = getStartFinishByOpMode[mode](activity_log);

    return <div className={[styles.duration, styles['margin-left']].join(' ')} data-is-more={more}>
        <Icon icon={ICON_NAME.CLOCK_2}/>
        <span>{durationTxt(finish - start)}</span>
    </div>;
};

export default Duration;
